import React, { useMemo, useState } from 'react';
import {
  FilterDateRangeNoMarginStyle,
  FilterDateRangeStyle,
  FilterSearchButtonStyle,
  FilterSearchConditionStyle,
} from '@components/organisms/Table/Filters/styles';
import moment from 'moment';
import { DateRange, DefaultButton, Input, Sub1Button, Select } from '@components/atoms';
import { StyledFilterWrapper } from './style';
import { css } from '@emotion/react';

interface Props {
  searchConditions?: any;
}

const PACSLogFilter = ({ searchConditions }: Props) => {
  const [searchKey, setSearchKey] = useState(searchConditions?.searchKey || 'Patient ID');
  const [searchKeyword, setSearchKeyword] = useState(searchConditions?.searchKeyword || '');
  const [filterDateRange, setFilterDateRange] = useState([
    {
      key: 'selection',
      startDate: searchConditions?.dateRange?.startDate ? new Date(searchConditions.dateRange.startDate) : null,
      endDate: searchConditions?.dateRange?.endDate ? new Date(searchConditions.dateRange.endDate) : null,
    },
  ]);

  const dateRange = useMemo(
    () => ({
      dateRange: {
        startDate: moment(filterDateRange[0].startDate).format('YYYY-MM-DD'),
        endDate: moment(filterDateRange[0].endDate).format('YYYY-MM-DD'),
      },
    }),
    [filterDateRange],
  );

  const changeHandler = (value: any) => {
    //
  };

  const doSearch = () => {
    //
  };

  return (
    <StyledFilterWrapper>
      <DateRange
        border
        isTabVisible={false}
        defaultValue={dateRange}
        dateRangeSet={filterDateRange}
        setDateRangeSet={setFilterDateRange}
        styles={FilterDateRangeStyle}
        placeholder={`Date`}
      />

      <Select
        styles={FilterSearchConditionStyle}
        selected={searchKey}
        onSelected={(selected) => setSearchKey(selected.value)}
        list={[
          { label: 'Patient ID', value: 'patientId' },
          { label: 'Patient Name', value: 'patientName' },
          { label: 'Study UID', value: 'studyUID' },
          { label: 'Series UID', value: 'seriesUID' },
          { label: 'Series Description', value: 'seriesDescription' },
          { label: 'AE Title', value: 'aetitle' },
        ]}
      />

      <Input
        styles={css`
          width: 240px;
        `}
        type="text"
        placeholder={`Search`}
        value={searchKeyword}
        onChange={(ev) => setSearchKeyword(ev.target.value)}
      />

      <Sub1Button styles={FilterSearchButtonStyle} onClick={doSearch}>
        Search
      </Sub1Button>
      <DefaultButton
        styles={css`
          width: 134px;
          height: 40px;
        `}
        onClick={doSearch}
      >
        Reset
      </DefaultButton>
    </StyledFilterWrapper>
  );
};

export default PACSLogFilter;
